import { render, staticRenderFns } from "./dashboard-library.vue?vue&type=template&id=0fcb84a2&"
import script from "./dashboard-library.vue?vue&type=script&lang=js&"
export * from "./dashboard-library.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-library.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports